import "./InputCheckList.scss";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { useEffect, useRef, useState } from "react";
import ErrorPopupBtn from "components/alert-popup/ErrorPopupBtn";
import { ErrorPopup } from "components/alert-popup/ErrorPopup";

const InputCheckList = ({
  value,
  infoList,
  onChange,
  readOnly,
  validation,
  errors,
  label,
  ...props
}) => {
  const [checkedValues, setCheckedValues] = useState(value || []);
  const itemsRef = useRef(infoList.map((elm) => elm.value));
  const [showErrorPopup, setShowErrorPopup] = useState(false);

  useEffect(() => {
    setCheckedValues(value || []);
  }, [value]);

  const formatCheckValues = (val) => {
    setCheckedValues((prevCheckedValues) => {
      const newValues = prevCheckedValues.includes(val)
        ? prevCheckedValues.filter((v) => v !== val)
        : [...prevCheckedValues, val];

      onChange(newValues);

      return newValues;
    });
  };

  const verifyChecked = (val) => checkedValues.includes(val);

  return (
    <div className="input-check-list">
      {infoList?.map(({ label, id }) => (
        <div
          style={{
            textAlign: "center",
            backgroundColor: "",
          }}
          className={`input-checks ${
            verifyChecked(label.id || id) ? "checked" : ""
          }checkbox-responsive`}
          key={label.id || id}
          onClick={() => itemsRef.current[label.id || id].click()}
        >
          <div>
            <input
              type="checkbox"
              id={`input-check-${label.id || id}`}
              value={label.id || id}
              onClick={() => itemsRef.current[label.id || id].click()}
              onChange={(e) => {
                if (!readOnly) {
                  formatCheckValues(e?.target.value);
                }
              }}
              checked={verifyChecked(label.id || id)}
              ref={(el) => {
                itemsRef.current[label.id || id] = el;
              }}
            />
            <label htmlFor={label.id || id} />
            <p>
              <FormattedMessage
                id={label.id || id}
                defaultMessage={label.defaultMessage || label}
              />
            </p>
          </div>
        </div>
      ))}
      {validation && <ErrorPopupBtn setShowErrorPopup={setShowErrorPopup} />}
      {showErrorPopup && (
        <ErrorPopup
          errors={errors}
          showErrorPopup={showErrorPopup}
          setShowErrorPopup={setShowErrorPopup}
          label={label || label?.id}
          errorMessage={props.errorMessage}
          errorValue={props.errorValue}
        />
      )}
    </div>
  );
};

InputCheckList.propTypes = {
  value: PropTypes.array,
  infoList: PropTypes.array,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  validation: PropTypes.bool,
  errors: PropTypes.object,
  errorMessage: PropTypes.string,
  errorValue: PropTypes.string,
  label: PropTypes.string,
};

export default InputCheckList;
